<!-- 
Contents of the NOTES tab of the levy collection provider page.
-->
<template>
  <div>
    <our-heading 
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle" 
      user-guide-topic="levy-collection-providers"
      user-guide-section="notes"
    >
      <template v-slot:additional-nav>
        <div class="hidden-md-and-down" style="position:relative;top:-4px;">
          <v-btn 
            :to="`/providers/${providerId}`" flat small color="primary" 
            class="mt-0 mb-0 mr-0"
          >
            <v-icon class="mr-2">school</v-icon>
            Go to provider
          </v-btn>
          <our-next-previous-navigator
            :nav-url="`/levy-collections/${levyCollectionId}/providers/:id/notes`"
            :next-page-action="nextPageAction"
            :previous-page-action="previousPageAction"
            id-field="providerId"
            module="levyCollectionProviders"
            class="mb-0"
          />
        </div>
      </template>
      <template v-slot:prefix>
        <favourite-indicator :provider="provider" />
      </template>
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" :sandbox="isSandbox" />
      </template>
    </our-heading>
    <tabs :levy-collection-id="levyCollectionId" :provider-id="providerId">
      <notes-listing :provider-id="providerId" :levy-collection-description="provider.levyCollectionDescription" @click="showEditor" />
      <note-edit-dialog v-model="showEditDialog" :note-id="noteId" :provider-id="providerId" :levy-collection-id="levyCollectionId" />
    </tabs>
  </div>
</template>

<script>
import levyCollectionProviderMixins from "./mixins";
import Tabs from "./Tabs.vue";
import NotesListing from "@/components/notes/NotesListing.vue";
import NoteEditDialog from "@/components/notes/NoteEditDialog.vue";
import FavouriteIndicator from "@/components/levy-collection-providers/FavouriteIndicator.vue";
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";

export default {
  name: "ProviderNotes",
  components: { Tabs, NotesListing, NoteEditDialog, FavouriteIndicator, LevyCollectionNavigator },
  mixins: [levyCollectionProviderMixins],
  data() {
    return {
      showEditDialog: false,
      noteId: null
    };
  },
  methods: {
    showEditor(noteId) {
      this.noteId = noteId;
      this.showEditDialog = true;
    }
  }
};
</script>
